import React, { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import {
  Drawer, IconButton, List, ListItem, ListItemIcon, ListItemText, Avatar,
} from '@material-ui/core';

import PerfectScrollbar from 'react-perfect-scrollbar';
import 'react-perfect-scrollbar/dist/css/styles.css';

import {
  MdDashboard, MdDateRange, MdMyLocation, MdPeople, MdLocalShipping,
  MdCardMembership, MdLocationOn, MdSettings, MdVerifiedUser,
} from 'react-icons/md';

import Menu from '@material-ui/icons/Menu';
import { FaAward, FaCalendarAlt, FaRegCalendarAlt } from 'react-icons/fa';

import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { IconType, IconBaseProps } from 'react-icons/lib';

import { useLocation } from 'react-router-dom';

import Logo from 'assets/images/logo512.png';
import AuthService, { UserProfile } from 'services/axios/AuthService';

import BulldevsLogo from 'assets/images/bulldevs.png';

// function useUsers() {
//   const currUser: firebase.User | undefined = useSession();
//   useEffect(() => {
//     console.log('useUsers: ' + JSON.stringify(users));
//     db
//       .collection('users')
//       .onSnapshot((snapshot: any) => {
//         const newUsers = snapshot.docs.map((doc: any) => {
//           return {
//             id: doc.id,
//             username: (currUser || {}).email,
//             nombre: 'no-data',
//             email: 'no-data',
//             estado: 'ACTIVO',
//             ...doc.data()
//           }
//         });
//         setUsers(newUsers)
//       })
//   }, [])
//   return users;
// }

// const getUserRole = async () => {
//   await firebase.auth().currentUser.getIdTokenResult();
//     .then((idTokenResult) => {
//       // Confirm the user is an Admin.
//       if (!!idTokenResult.claims.role) {
//       } else {
//         // Show regular user UI.
//         showRegularUI();
//       }
//     })
//     .catch((error) => {
//       console.log(error);
//     });  
// }

interface AppPage {
  url: string;
  title: string;
  icon: IconType;
}

const adminPages: AppPage[] = [
  {
    title: 'Dashboard',
    url: '/admin/dashboard',
    icon: (props: IconBaseProps) => <MdDashboard {...props} />
  },
  {
    title: 'Cronograma',
    url: '/admin/cronograma',
    icon: (props: IconBaseProps) => <MdDateRange {...props} />
  },
  {
    title: 'Clientes',
    url: '/admin/clientes',
    icon: (props: IconBaseProps) => <MdMyLocation {...props} />
  },
  {
    title: 'Usuarios',
    url: '/admin/usuarios',
    icon: (props: IconBaseProps) => <MdPeople {...props} />
  },
  {
    title: 'Operadores',
    url: '/admin/operadores',
    icon: (props: IconBaseProps) => <MdLocalShipping {...props} />
  },
  {
    title: 'Certificados',
    url: '/admin/certificados',
    icon: (props: IconBaseProps) => <MdCardMembership {...props} />
  },
  {
    title: 'Servicios',
    url: '/admin/servicios/crear',
    icon: (props: IconBaseProps) => <MdLocationOn {...props} />
  },
  {
    title: 'Productos habilitados',
    url: '/admin/configuracion/productos/habilitados',
    icon: (props: IconBaseProps) => <MdVerifiedUser {...props} />
  },
  {
    title: 'Configuración',
    url: '/admin/configuracion/editar',
    icon: (props: IconBaseProps) => <MdSettings {...props} />
  }
];


const clientePages: AppPage[] = [
  {
    title: 'Dashboard',
    url: '/cliente/dashboard',
    icon: (props: IconBaseProps) => <MdDashboard {...props} />
  },
  {
    title: 'Certificados',
    url: '/cliente/certificados',
    icon: (props: IconBaseProps) => <FaAward {...props} />
  },
  {
    title: 'Servicios Programados',
    url: '/cliente/servicios',
    icon: (props: IconBaseProps) => <FaCalendarAlt {...props} />
  },
  {
    title: 'Productos Habilitados',
    url: '/cliente/productos/habilitados',
    icon: (props: IconBaseProps) => <MdVerifiedUser {...props} />
  }
];

const operadorPages: AppPage[] = [
  {
    title: 'Servicios',
    url: '/operador/dashboard',
    icon: (props: IconBaseProps) => <FaRegCalendarAlt {...props} />
  }
];

interface ComponentProps {
  handleDrawerClose: React.MouseEventHandler<HTMLElement>;
  open: boolean;
};

export const Sidebar: React.FC<ComponentProps> = (props) => {
  const classes = useStyles();
  const location = useLocation();
  // const history = useHistory();
  const [currentUser, setCurrentUser] = useState<UserProfile>();
  const [currentPages, setCurrentPages] = useState<AppPage[]>([]);

  useEffect(() => {
    const fetchUser = async () => {
      const currentUser = await AuthService.fetchCurrentUserFromStorage();
      let currentPages: AppPage[] = [];
      switch (currentUser.role) {
        case "admin":
          currentPages = adminPages;
          break;
        case "cliente":
          currentPages = clientePages;
          break;
        case "operador":
          currentPages = operadorPages;
          break;
        default:
          break;
      }
      setCurrentUser(currentUser);
      setCurrentPages(currentPages);
    }
    fetchUser();
  }, []
  );

  // const cerrarSesion = () => {
  //   AuthService.logout().then(() => { history.push("/login"); });
  // }

  //just for forwarding the ref to RouterLink 
  const NavLink = React.forwardRef((props: any, ref: any) => <RouterLink ref={ref} {...props} />);

  return (
    <Drawer
      variant="persistent"
      anchor="left"
      open={props.open}
      classes={{ paper: classes.drawerPaper }}
    >
      <PerfectScrollbar >
        <div className={classes.drawerHeader}>
          <IconButton onClick={props.handleDrawerClose} color="inherit">
            <Menu />
          </IconButton>
        </div>
        <div className={classes.drawerSubHeader}>
          <div className={classes.drawerSubHeaderTitle}>{currentUser?.name}</div>
          <div className={classes.drawerSubHeaderSubTitle}>{currentUser?.email}</div>
          <div className={classes.drawerSubHeaderAvatarContainer}>
            <Avatar src={Logo} className={classes.drawerSubHeaderAvatar} alt="logo" />
          </div>
        </div>
        <List className={classes.list}>
          {currentPages.map((appPage, index) => {
            return (
              <ListItem button dense key={appPage.title}
                component={NavLink} to={appPage.url}
                onClick={props.handleDrawerClose}
                className={[
                  classes.listItem,
                  location.pathname === appPage.url ? classes.listItemActive : ''
                ].join(' ')}
              >
                <ListItemIcon
                  className={[
                    classes.listItemIcon,
                    location.pathname === appPage.url ? classes.listItemActive : ''
                  ].join(' ')}
                >
                  {appPage.icon({ size: 24, color: "primary" })}
                </ListItemIcon>
                <ListItemText primary={appPage.title} />
              </ListItem>
            );
          })}
        </List>
      </PerfectScrollbar>
      {
        currentUser?.role === "cliente"
          ?
          <ListItem button
            onClick={() => openInNewTab('https://bulldevs.com')}
            style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(0, 0, 0, 0.04)' }}
          >
            <img src={BulldevsLogo} alt="bulldevs" style={{ maxHeight: 10, marginLeft: 12, marginRight: 12 }} />
          </ListItem>
          :
          <></>
      }
    </Drawer >
  );
}

function openInNewTab(url) {
  var win = window.open(url, '_blank');
  if (win) win!.focus();
}

const useStyles = makeStyles((theme: Theme) => {
  const drawerWidth = 280;
  const drawerColor = {
    color: '#2d323e',
    backgroundColor: '#fff'
  }
  const listItemColor = {
    color: drawerColor.color,
    backgroundColor: drawerColor.backgroundColor,
    hoverBackgroundColor: 'rgba(0,0,0,.05)'
  };
  const listItemActiveColor = {
    color: '#2d323e',
    backgroundColor: '#fdd835',
  };
  const headerColor = {
    color: '#fff',
    subColor: '#ccc',
    backgroundColor: theme.palette.primary.main,
    avatarBackgroundColor: '#fff'
  }
  return createStyles({
    drawerPaper: {
      width: drawerWidth,
      borderRight: 0,
      fontSize: 10,
      backgroundColor: drawerColor.backgroundColor,
      boxShadow:
        "0 16px 24px 2px rgba(0, 0, 0, 0.14), 0 6px 30px 5px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
    },
    drawerHeader: {
      ...theme.mixins.toolbar,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
      padding: theme.spacing(0, 1),
      color: headerColor.color,
      backgroundColor: headerColor.backgroundColor,
    },
    drawerSubHeader: {
      position: 'relative',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start',
      alignItems: 'center',
      textAlign: 'center',
      height: 120,
      backgroundColor: headerColor.backgroundColor
    },
    drawerSubHeaderTitle: {
      color: headerColor.color,
      fontSize: '1.25rem'
    },
    drawerSubHeaderSubTitle: {
      color: headerColor.subColor,
      fontSize: '0.6875rem',
      paddingTop: 5,
    },
    drawerSubHeaderAvatarContainer: {
      position: 'absolute',
      backgroundColor: headerColor.backgroundColor,
      top: 60,
      padding: 12,
      borderRadius: '50%',
      zIndex: 99199,
    },
    drawerSubHeaderAvatar: {
      width: theme.spacing(10),
      height: theme.spacing(10),
      backgroundColor: headerColor.avatarBackgroundColor,
      padding: 8
    },
    list: {
      paddingTop: 60,
      paddingRight: 20,
    },
    listItem: {
      color: listItemColor.color,
      backgroundColor: listItemColor.backgroundColor,
      borderRadius: '0 48px 48px 0',
      padding: '5px 20px, 5px 0',
      '&:hover': {
        backgroundColor: listItemColor.hoverBackgroundColor
      }
    },
    listItemIcon: {
      color: listItemColor.color,
      minWidth: '40px'
    },
    listItemActive: {
      color: listItemActiveColor.color,
      backgroundColor: listItemActiveColor.backgroundColor,
      '&:hover': {
        color: listItemActiveColor.color, //overrides base hover
        backgroundColor: listItemActiveColor.backgroundColor,//overrides base hover
      }
    },
    nested: {
      paddingLeft: theme.spacing(4),
    },
  })
}
);

export default Sidebar;